import { F as p, E as r } from "./resize-bus-BJO1V4ET.js";
import { defineAsyncComponent as o } from "vue";
import { $gmapOptions as a } from "./keys.es.js";
import { g as t, p as l } from "./plugin-component-builder-BiLBj3aj.js";
globalThis.GoogleMapsApi = { isReady: !1 };
function s() {
  return globalThis.GoogleMapsApi.isReady && globalThis.google;
}
const d = {
  googleMapsApiInitializer: t,
  pluginComponentBuilder: l,
  getGoogleMapsAPI: s
}, f = (m) => (e) => {
  const i = {
    dynamicLoad: !1,
    ...m,
    load: {
      libraries: "places",
      ...m.load
    }
  }, n = r(
    t,
    globalThis.GoogleMapsApi
  )(i);
  p(i, n), e.config.globalProperties.$gmapApiPromiseLazy = n, e.config.globalProperties.$gmapOptions = i, e.provide(a, i), e.component(
    "GmvMap",
    o(() => import("./map-layer-Ep0p34Fn.js"))
  ).component(
    "GmvMarker",
    o(() => import("./marker-icon-c1QrUDJ7.js"))
  ).component(
    "GmvInfoWindow",
    o(() => import("./info-window-D5-TkRc2.js"))
  ).component(
    "GmvKmlLayer",
    o(() => import("./kml-layer-BTC8Lyev.js"))
  ).component(
    "GmvAutocomplete",
    o(
      () => import("./autocomplete-input-CU6sc4MS.js")
    )
  ).component(
    "GmvStreetViewPanorama",
    o(
      () => import("./street-view-panorama-CD_sAJPw.js")
    )
  ).component(
    "GmvHeatmapLayer",
    o(() => import("./heatmap-layer-BveiTyRz.js"))
  ).component(
    "GmvCircle",
    o(() => import("./circle-shape-C7UFwSSJ.js"))
  ).component(
    "GmvPolygon",
    o(() => import("./polygon-shape-kRo7s5LF.js"))
  ).component(
    "GmvPolyline",
    o(() => import("./polyline-shape-CnE69MAC.js"))
  ).component(
    "GmvRectangle",
    o(() => import("./rectangle-shape-Zz33RQkK.js"))
  ).component(
    "GmvDrawingManager",
    o(() => import("./drawing-manager-lgrqolZZ.js"))
  ).component(
    "GmvCluster",
    o(() => import("./cluster-icon-D4iLEiEZ.js"))
  );
};
export {
  f as createGmapVuePlugin,
  d as utilities
};
